import Vue from 'vue'
import Router from 'vue-router'
import moment from 'moment'

import store from './store'
import auth from '@/auth/initAuth'
import Agendamentos from '@/pages/agendamentos/routes'
import AplicativoCategorias from '@/pages/aplicativo-categorias/routes'
import AplicativosSegmentos from '@/pages/aplicativo-segmentos/routes'
import Aplicativos from '@/pages/aplicativos/routes'
import Campanhas from '@/pages/campanhas/routes'
import ApuracaoMensal from '@/pages/apuracao-mensal/routes'
import Callback from '@/pages/callback/Callback'
import CentroDistribuicao from '@/pages/centro-distribuicao/routes'
import Dashboard from '@/pages/dashboard/Dashboard'
import DistribuicaoEquipamentos from '@/pages/distribuicao-equipamentos/routes'
import Equipamentos from '@/pages/equipamentos/routes'
import Login from '@/pages/login/Login'
import RecadastrarSenha from '@/pages/login/RecadastrarSenha'
import RecuperarSenha from '@/pages/login/RecuperarSenha'
import MotoristaPendenciaMotivo from '@/pages/motorista-pendencia-motivo/routes'
import Motorista from '@/pages/motorista/routes'
import OcorrenciaMotivo from '@/pages/ocorrencia-motivo/routes'
import Ocorrencias from '@/pages/ocorrencias/routes'
import Parametros from '@/pages/parametros/routes'
import PontoApoio from '@/pages/ponto-apoio/routes'
import ServicoMotivo from '@/pages/servico-motivo/routes'
import ServicoTipo from '@/pages/servico-tipo/routes'
import UsuariosPontoApoio from '@/pages/usuarios-ponto-apoio/routes'
import Usuarios from '@/pages/usuarios/routes'
import MensagemConfig from '@/pages/mensagem-config/routes'
import Mensagens from '@/pages/mensagens/routes'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    { path: '/login', name: 'Login', component: Login },
    {
      path: '/recadastrar-senha',
      name: 'RecadastrarSenha',
      component: RecadastrarSenha
    },
    {
      path: '/esqueci-senha',
      name: 'RecuperarSenha',
      component: RecuperarSenha
    },
    { path: '/callback', name: 'Callback', component: Callback },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    { path: '/dashboard', redirect: '/', meta: { requiresAuth: true } },
    Usuarios,
    UsuariosPontoApoio,
    Parametros,
    Campanhas,
    Aplicativos,
    AplicativoCategorias,
    AplicativosSegmentos,
    MotoristaPendenciaMotivo,
    OcorrenciaMotivo,
    ServicoTipo,
    ServicoMotivo,
    Ocorrencias,
    Equipamentos,
    CentroDistribuicao,
    PontoApoio,
    Motorista,
    Agendamentos,
    ApuracaoMensal,
    DistribuicaoEquipamentos,
    MensagemConfig,
    Mensagens
  ]
})

const logout = (to, next) => {
  if (localStorage.getItem('jwt') !== null) {
    localStorage.removeItem('user')
    localStorage.removeItem('jwt')
    localStorage.removeItem('expires_login')
  }

  store.commit('setAuthenticated', false)

  next({
    path: '/login',
    params: { nextUrl: to.fullPath }
  })
}

const isExpired = () => {
  const expiresLogin = localStorage.getItem('expires_login')

  return !expiresLogin || moment().isAfter(moment(expiresLogin))
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null || !auth.loggedIn() || isExpired()) {
      logout(to, next)
    } else {
      const user = JSON.parse(localStorage.getItem('user'))

      store.commit('setAuthenticated', true)

      if (to.matched.some(record => record.meta.is_admin)) {
        if (user.is_admin === 1) {
          next()
        } else {
          next({
            name: 'Dashboard'
          })
        }
      } else {
        next()
      }
    }
  } else {
    if (to.path.startsWith('/access_token')) {
      window.location.href =
        window.location.origin + '/#/callback#' + to.fullPath.substring(1)
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/routes.js